export default class WechatAppRouter {
}
WechatAppRouter.getPageInfo = () => {
    const pages = getCurrentPages();
    if (pages.length === 0) {
        throw new Error("[MultiEnd] getRouter => Page num is zero");
    }
    const page = pages[pages.length - 1];
    return {
        path: `/${page.route}`,
        query: page.options,
    };
};
